import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setVehiclesConfig } from '../actions/actionsAppTest'
import { fetchSimulationVehiclesIfNeeded } from '../actions/actionsApiSimulation'
import TestVehicles from '../components/testCriteria/TestVehicles'

export default function ContTestVehiclesConfig() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeVehicles(vehicles) {
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, { vehiclesConfig: vehicles }, null, null, false);
    dispatch(setVehiclesConfig(vehicles));
  }
  return (
    <TestVehicles
      context={globalstate.testCriteria.context}
      data={globalstate.testCriteria.vehiclesConfig}
      settings={globalstate.settings}
      disableOptionsAccessories={true}
      onChangeVehicles={onChangeVehicles}
    />
  );
}
